import React, { CSSProperties, FunctionComponent } from "react"
import { IconButton, Paper } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import Grid from "@mui/material/Grid"
import Card from "@mui/material/Card"
import { GraphNodeType } from "@custom-types/graphs"

interface Props {
  onCloseClick: () => void
}

const nodeStyle: CSSProperties = {
  paddingLeft: 15,
  width: 100,
  height: 30,
  position: "relative",
  transform: "scale(1.2)",
}

const descriptions: { [key: string]: string } = {}
descriptions[GraphNodeType.CONTINOUS] = "Continuous node is defined by a distribution."
descriptions[GraphNodeType.MIXTURE] =
  "Mixture node is combined discrete and deterministic node values."
descriptions[GraphNodeType.DISCRETE] =
  "Discrete node is combined continuous and deterministic node values."
descriptions[GraphNodeType.CATEGORICAL] =
  "Categorical node is node with column categories that each row values probability sums to 1."
descriptions[GraphNodeType.DETERMINISTIC] =
  "Deterministic node is defined by a value or expression with parent node values."
descriptions[GraphNodeType.TABLE] = "Table node define constraint values as a table."
descriptions[GraphNodeType.LAG] =
  "Lag node populates data for the prior timestep in a multistep graph, these can be fixed values or expression with parent node values."
descriptions[GraphNodeType.FORECAST] =
  "Forecast node is defined by value from scenario file using 'Forecast Mnem' attribute."
descriptions[GraphNodeType.SCENARIO] =
  "Scenario node is defined by value from scenario file using 'Scenario Mnem' attribute."

export const GraphNodeTypePopper: FunctionComponent<Props> = ({ onCloseClick }) => {
  const nodeTypes = Object.values(GraphNodeType)
    .filter((type) => type !== GraphNodeType.GROUP)
    .map((type) => {
      return (
        <div
          key={type}
          className="graph-editor"
          style={{
            padding: "5px 0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #ccc",
          }}
        >
          <div style={nodeStyle}>
            <div className="graph-node-container">
              <div className={`graph-node-type graph-node-${type}`}>{type}</div>
              <div className="graph-node-label">sample node</div>
            </div>
          </div>
          <div style={{ maxWidth: 200 }}>{descriptions[type]}</div>
        </div>
      )
    })

  return (
    <Paper
      sx={{
        p: 1,
        mt: "1px",
        ml: "-2px",
        boxShadow:
          "0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)",
        borderRadius: "5px !important",
        border: "1px solid #ccc !important",
      }}
    >
      <Grid container sx={{ marginBottom: "1px" }}>
        <div style={{ display: "flex", width: "100%", justifyContent: "flex-end" }}>
          <IconButton aria-label="Close" onClick={onCloseClick}>
            <CloseIcon />
          </IconButton>
        </div>
        <Card
          sx={{
            padding: 1,
            width: "100%",
            minWidth: "300px",
            minHeight: "200px",
            maxHeight: "300px",
            overflowY: "auto",
            boxShadow: "none",
            borderRadius: "5px !important",
          }}
        >
          {nodeTypes}
        </Card>
      </Grid>
    </Paper>
  )
}
